import { useQueryClient } from '@tanstack/react-query'
import { useUserDefaultShoppingAddressId } from '@/features/account/services/User/hooks'
import { lastDeliveredOrderQueryOptions } from '@/features/shop/services/Orders/queryOptions'
import { useShopSessionFlagValue } from '@/features/shop/state/ShopSessionFlags/atoms'
import { useCurrentActiveOrderId } from '@/features/shop/state/SelectedActiveOrder/hooks'

/** returns true when the user's address has not changed from the previous gift address */
export const useShouldConfirmAddress = (): boolean => {
  const queryClient = useQueryClient()
  const lastPlacedOrder = queryClient.getQueryData(lastDeliveredOrderQueryOptions.queryKey)
  const hasActiveOrder = !!useCurrentActiveOrderId()
  const addressId = useUserDefaultShoppingAddressId()
  const hasConfirmedAddress = useShopSessionFlagValue('confirmedAddress')
  return Boolean(
    !hasConfirmedAddress &&
    !hasActiveOrder &&
    lastPlacedOrder?.is_gift &&
    addressId === lastPlacedOrder.customer_address_id,
  )
}
